import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import { SCHEDULED_TRANSFERS } from './constants'
import axios, { AxiosError } from 'axios'
import queryKeys from './queryKeys'

const baseUrl = getAppConfigSetting('apiUrl')
const scheduledTransfersURL = `${baseUrl}${SCHEDULED_TRANSFERS}`

type SetError = (error: AxiosError) => void
type AccountNumber = string | undefined

export default function useGetSchedules(accountNumber: AccountNumber) {
  const getScheduleTransfersList = async () => {
    return await axios.get(`${scheduledTransfersURL}`, {
      params: { accountNumber: accountNumber },
      withCredentials: true
    })
  }

  return useQuery([queryKeys.scheduledTransfers, accountNumber], getScheduleTransfersList, {
    // The query will not execute until the accountNumber exists
    enabled: !!accountNumber
  })
}
